import React, { useState, useEffect } from 'react'
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useNavigate } from "react-router-dom";

function Leaveapply() {

    const navigate = useNavigate();

    const leaveapplyadd = () => {
        navigate("/leaveapplyadd")
    }



    return (

        <>
            <Sidennav />
            <Topnavbar />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <div className="col-lg-12">

                            <div className="card">

                                <div class="card-header" style={{ "color": "black" }}>
                                    <h6 class="card-title"> Leave Details
                                    </h6>


                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            onClick={() => leaveapplyadd()}

                                            style={{ marginRight: '50px' }} // Adjust spacing as needed
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Apply Leave</span>
                                        </button>
                                    </div>

                                </div>


                                <div className="card-body">



                                    <div className="card">

                                        <div className="card-body">


                                            <div className="table-responsive">
                                                <table className="table table-bordered table-responsive-sm">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ "textAlign": "center" }}>Sl.no</th>
                                                            {/* <th style={{ "textAlign": "center" }}>Staff Name</th> */}
                                                            <th style={{ "textAlign": "center" }}>Leave Date</th>
                                                            <th style={{ "textAlign": "center" }}>Reason for Leave</th>

                                                            <th style={{ "textAlign": "center" }}>Edit</th>


                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>

                                                            <td>1</td>
                                                            <td>12-08-2024</td>
                                                            <td>Fever</td>


                                                            <td style={{ textAlign: "center" }}> <i
                                                                class="text-primary fa fa-edit"
                                                                style={{ cursor: "pointer" }}

                                                            ></i></td>


                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div></div>













        </>



    )

}

export default Leaveapply